module.exports = __webpack_public_path__ + "static/media/GG_rewards.eb8d5254.svg";